export default {
    '个人中心':'Personal Center',  
    '编辑个人资料':'Edit Profile',  
    '编辑个人领域信息':'Edit Domain Information',  
    '本机构信息':'Organization Information',  
    '编辑机构信息':'Edit Organization Info',  
    '设备管理':'Device Management',  
    '场所管理':'Venue Management',  
    '关联设备':'Associated Devices',  
    '学年学期':'Academic Year/Semester',  
    '新增学年':'Add Academic Year',  
    '编辑学年':'Edit Academic Year',  
    '入学年份':'Enrollment Year',  
    '班级管理':'Class Management',  
    '教职工':'Faculty/Staff',  
    '新增教职工':'Add Staff',  
    '编辑教职工':'Edit Staff',  
    '市民':'Citizen',  
    '新增市民':'Add Citizen',  
    '编辑市民':'Edit Citizen', 
    '学生':'Student',  
    '新增学生':'Add Student',  
    '编辑学生':'Edit Student',  
    '家长':'Parent',  
    '编辑家长':'Edit Parent',  
    '角色管理':'Role Management',  
    '新增角色':'Add Role',  
    '编辑角色':'Edit Role',  
    '管理成员':'Manage Members',  
    '测试管理':'Test Management',  
    '新增计划':'Add Plan',  
    '查看计划':'View Plan',  
    '成绩查询':'Grade Inquiry',  
    '测试记录':'Test Records',  
    '锻炼记录':'Exercise Records',  
    '竞技排名赛':'Competition Ranking Event',  
    '新增竞技排名赛':'Add Competition Event',  
    '编辑竞技排名赛':'Edit Competition Event',  
    '竞技排名赛详情':'Competition Details',  
    '竞技排名赛数据':'Competition Data',  
    '作业管理':'Assignment Management',  
    '发布作业':'Publish Assignment',  
    '作业详情':'Assignment Details',  
    '编辑作业':'Edit Assignment',  
    '测试结果':'Test Results',  
    '详情':'Details',  
    '随堂练':'In-class Exercise',  
    '随堂测':'In-class Test',  
    '随堂练':'In-class Exercise',  
    '随堂赛':'In-class Match',  
    '个性化训练列表':'Personalized Training List',  
    '新增个性化训练':'Add Personalized Training',  
    '查看个性化训练':'Explore Personalized Training',  
    '数据列表':'Data List',  
    '运动会管理':'Sports Meet Management',  
    '新增运动会':'Add Sports Meet',  
    '管理运动会':'Manage Sports Meet',  
    '编排':'Scheduling',  
    '日程表':'Schedule',  
    '运动风采':'Sports Showcase',  
    '学校画像':'School Profile',  
    '年级画像':'Grade Profile',  
    '班级画像':'Class Profile',  
    '班级详情':'Class Details',  
    '学生画像':'Student Profile',  
    '院系管理':'Department Management',  
    '专业管理':'Major Management',  
    '赛事列表':'Event List',  
    '新增闯关挑战赛':'Add Challenge Event',  
    '编辑闯关挑战赛':'Edit Challenge Event',  
    '闯关挑战赛详情':'Challenge Details',  
    '新增机构':'Add Organization',  
    '编辑机构':'Edit Organization',  
    '查看机构':'View Organization',  
    '组织结构管理':'Organizational Structure Management',  
    '用户管理':'User Management',  
    '新增用户':'Add User',  
    '编辑用户':'Edit User',  
    '资源列表':'Resource List',
    '新增资源':'Add Resource',
    '编辑资源':'Edit Resource',
    '校本资源':'Institutional Resources',
    '新增校本资源':'Add Institutional Resources',
    '编辑校本资源':'Edit Institutional Resources',
    // 2025.3.19

    // 2025.5.21
    'Banner配置':'Banner Configuration',  
    '编辑Banner配置':'Edit Banner Config',  
    '查看Banner配置':'View Banner Config',  
    '资源分类':'Resource Categories', 

    // 2026.1.4
    '自由锻炼':'Free exercise',
    '趣味锻炼':'Fun exercise',
    '机构主页管理':'Organization Homepage Management',
    '主页发布管理':'Homepage Publishing Management',
    '分类管理':'Category Management',
    '新增主页':'Add Homepage',
    '编辑主页':'Edit Homepage',

    // 2026.6.25
    '宣传页管理':'Promotion Page Management',
    '宣传页配置':'Promotion Page Configuration',
    '新增宣传页':'Add Promotion Page',
    '编辑宣传页':'Edit Promotion Page',
}